import type {UserMappingObject} from './usersStore.types';
import type {User} from '@myparcel-frontend/types';
import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useUsersStore = defineStore('users', () => {
  const userList = ref<User[]>([]);
  const userIdToUsername = ref<UserMappingObject>();

  const getUsersByShopIds = (shopIds: string[]): User[] => {
    const shopIdSet = new Set(shopIds.map(Number));
    const userContainsShopId = (user: User) =>
      user.accessible_shop_ids.some((shop) => {
        return shopIdSet.has(shop);
      });

    return userList.value.filter((user: User) => user.all_shop_access || userContainsShopId(user));
  };

  const getUsernameByUserId = (id: string): string | undefined => {
    return userIdToUsername.value?.[id];
  };

  const updateUserMapping = () => {
    const userMap: UserMappingObject = userList.value.reduce((acc: UserMappingObject, user) => {
      acc[user.id.toString()] = `${user.contact.first_name} ${user.contact.last_name}`;
      return acc;
    }, {});

    userIdToUsername.value = userMap;
  };

  const updateUserList = (users: User[]) => {
    userList.value = [...userList.value, ...users];
    updateUserMapping();
  };

  return {
    userList,
    getUsersByShopIds,
    updateUserList,
    getUsernameByUserId,
  };
});
